export const ValidateDeclarationStep = Object.freeze({ validate: 0, summary: 1 });

// Schemes with a built Validate Declaration section list — PLUS/CORSIA await their own spec.
export const SECTIONS_BY_SCHEME = Object.freeze({ ISCC_EU: true });

// Re-exported so the slice keeps its import path; the vocabularies live in config (CLAUDE.md).
export {
  GHG_DEFAULT_VALUE,
  MULTISITE_TRANSFER_VALUE,
  YES_NO_VALUE,
  CHAIN_OF_CUSTODY_OPTION,
  ESCA_BONUS_CAP,
} from '@/config/declarationOptions';
